<template>
  <div class="withdraw">
    <van-sticky>
      <van-nav-bar title="申请提现" left-arrow @click-left="goback()" />
    </van-sticky>
    <div class="withdraw_content">
      <div class="fs14 color333 font-weightbold">佣金提现</div>
      <div class="content_input">
        <div>￥</div>
        <input placeholder="请输入金额" :value="amount" @change="changeAmount" />
      </div>
      <div class="content_pay fs12 color999">
        可提现金额：￥{{userInfo.canCash}} ,
        <span @click="withdrawAll">全部提现</span>
      </div>
      <van-radio-group v-model="checked">
        <van-radio name="2">提现到银行卡</van-radio>
        <div class="radio_bankcard">
          <van-form>
            <van-cell-group :border="false">
              <van-field v-model="submitData.bankName" :border="false" is-link input-align="right" :value="submitData.bankName" label="银行" placeholder="请输入" />
              <van-field v-model="submitData.bankAccount" :border="false" is-link input-align="right" :value="submitData.bankAccount" label="账户名称" placeholder="请输入" />
              <van-field v-model="submitData.bankCardNumber" :border="false" is-link input-align="right" :value="submitData.bankCardNumber" label="银行卡号" placeholder="请输入" />
              <van-field v-model="submitData.bankSubBranch" :border="false" is-link input-align="right" :value="submitData.bankSubBranch" label="开户支行" placeholder="请输入" />
            </van-cell-group>
          </van-form>
        </div>
        <van-radio name="1">提现到微信钱包</van-radio>
      </van-radio-group>
      <van-button class="m-t30" color="#F6C545" block @click="open">确认提现</van-button>
    </div>
    <div class="withdraw_history" @click="toWithdrawDetail()">
      查看历史提现记录
    </div>
  </div>
</template>
<script>
import {
  Button,
  NavBar,
  Icon,
  Sticky,
  RadioGroup,
  Radio,
  Form,
  Field,
  CellGroup,
  ActionSheet,
  Notify,
  Toast,
  Dialog,
} from "vant";

export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      amount: 0,
      checked: "2", //打款方式，1-微信/2-银行卡/3-支付宝/4-现金
      submitData: {
        bankName: "",
        bankAccount: "",
        bankCardNumber: "",
        bankSubBranch: "",
      },
      userInfo: "",
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    //跳转提现明细界面
    toWithdrawDetail() {
      this.$router.push({ path: "/distribution/withdrawDetail" });
    },

    //获取分销用户信息
    getUserInfo() {
      let that = this;
      that.$api.distributorIndexAPI("").then(function(res) {
        if (res.data.code == 200) {
          that.userInfo = res.data.data
        } else {
          Notify({ type: "danger", message: '接口返回异常：' + res.data.message });
        }
      }).catch(function(err) {
        Notify({ type: "danger", message: JSON.stringify(err) });
      })
    },

    //全部提现
    withdrawAll() {
      let cash = 0;
      if((typeof this.userInfo.canCash=='string')&&this.userInfo.canCash.constructor==String){
        cash = this.userInfo.canCash.replace('元','')
      }else{
        cash = this.userInfo.canCash
      }
      this.amount = parseFloat(cash)
    },

    changeAmount(e) {
      this.amount = parseFloat(e.target.value)
      if (this.amount > this.userInfo.canCash) {
        Notify({ type: "danger", message: '可提现金额不足' });
      }
    },

    //是否提现
    open() {
      let that = this;
      Dialog.confirm({
          title: '提示',
          message: '请确认是否提现',
        })
        .then(() => {
          // on confirm
          that.submitInfo()
        })
        .catch(() => {
          // on cancel
        });
    },

    //立即提现
    submitInfo() {
      if (this.submitData.bankName == "" && this.checked == "2") {
        Notify({ type: "danger", message: '请输入提现银行名称' });
        return false;
      }
      if (this.submitData.bankAccount == "" && this.checked == "2") {
        Notify({ type: "danger", message: '请输入提现银行账户' });
        return false;
      }
      if (this.submitData.bankCardNumber == "" && this.checked == "2") {
        Notify({ type: "danger", message: '请输入提现银行卡号' });
        return false;
      } else if ((this.submitData.bankCardNumber != "" && this.checked == "2")) {
        let pattern = /^([1-9]{1})(\d{15}|\d{16}|\d{18})$/
        let str = this.submitData.bankCardNumber.replace(/\s+/g, "");
        if (!pattern.test(str)) {
          Notify({ type: "danger", message: '银行卡卡号格式错误，请正确输入银行卡号！' });
          return false;
        }
      }
      if (this.submitData.bankSubBranch == "" && this.checked == "2") {
        Notify({ type: "danger", message: '请输入提现开户支行名称' });
        return false;
      }
      if (this.amount <= 0) {
        Notify({ type: "danger", message: '可提现金额要大于0' });
        return false;
      }
      if (this.amount > this.userInfo.canCash) {
        Notify({ type: "danger", message: '可提现金额不足' });
        return false;
      }

      let params = (this.checked == "2") ? {
        amount: this.amount,
        paymentMethod: this.checked,
        bank_name: this.submitData.bankName,
        bank_account: this.submitData.bankAccount,
        bank_cardNumber: this.submitData.bankCardNumber,
        bank_subBranch: this.submitData.bankSubBranch,
      } : {
        amount: this.amount,
        paymentMethod: this.checked,
      };
      this.submitWithdrawInfo(params)
    },

    //申请提现
    submitWithdrawInfo(params) {
      // 自定义加载图标
      Toast.loading({
        message: '提交中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      });
      let that = this;
      that.$api.userH5ApplySaveAPI(params).then(function(res) {
        if (res.data.code == 200) {
          setTimeout(() => {
            Toast.clear()
            Notify({ type: "success", message: '提现申请提交成功，请耐心等待' });
            that.getUserInfo();
            that.amount = 0;
          }, 1500)
        } else {
          Notify({ type: "danger", message: '接口返回异常：' + res.data.message });
        }
      }).catch(function(err) {
        setTimeout(() => {
          Toast.clear()
          Notify({ type: "danger", message: JSON.stringify(err) });
        }, 1500)
      })
    },

  },
};

</script>
<style lang="less" scoped>
.withdraw {
  .withdraw_content {
    margin: 10px 20px;
    padding: 20px 15px;
    background: #fff;
    border-radius: 4px;

    .content_input {
      margin-top: 15px;
      display: flex;
      align-items: flex-end;
      padding: 15px 0px;
      border-bottom: 1px solid #f3f3f3;
      font-size: 25px;

      input {
        border: unset;
        font-size: 30px;
        width: 100%;
      }

      /* 更改文本框的placeholder的颜色 */
      input::placeholder {
        font-size: 18px;
      }
    }

    .content_pay {
      padding: 20px 0px;

      span {
        color: #f6c545;
      }
    }
  }

  .radio_bankcard {
    margin-left: 10px;
    padding: 10px 0px;

    /deep/ .van-field__control {
      color: #999;
    }
  }

  .van-radio {
    font-size: 15px;
    font-weight: bold;
  }

  .withdraw_history {
    text-align: center;
    margin-top: 25px;
    font-size: 14px;
    text-decoration: underline;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/distribution/withdraw.vue